import React, { useEffect, useState } from "react";
import api from "../api/api"; // Импортируем экземпляр API

import {
  Container,
  Typography,
  TextField,
  Button,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { useParams } from "react-router-dom"; // Импортируем useParams

function Chat() {
  const { id } = useParams(); // Получаем id клиента из URL
  const [userMessage, setUserMessage] = useState("");
  const [chatResponses, setChatResponses] = useState([]);

  // Функция для загрузки всех сообщений клиента
  const fetchChatMessages = async () => {
    try {
      const response = await api.get(`/clients/${id}/chat-messages`);
      setChatResponses(response.data);
    } catch (error) {
      console.error("Ошибка при загрузке сообщений:", error);
      alert("Не удалось загрузить сообщения чата.");
    }
  };

  // Используем useEffect для загрузки сообщений при рендеринге компонента
  useEffect(() => {
    fetchChatMessages();
  }, []); // Загружаем сообщения только один раз при монтировании компонента

  // Функция отправки сообщения
  const sendMessage = async () => {
    if (!userMessage) {
      alert("Пожалуйста, введите сообщение.");
      return;
    }

    try {
      // Отправляем POST запрос на сервер с использованием query параметров
      const response = await api.post(
        `/chat/?client_id=${id}&user_message=${encodeURIComponent(userMessage)}`
      );

      console.log("Ответ от сервера:", response.data);

      // Добавляем новое сообщение клиента и ответ ассистента в массив
      const newClientMessage = {
        client_id: parseInt(id),
        content: userMessage,
        is_client_message: true,
        is_manager_message: false, // Это сообщение клиента, не менеджера
        timestamp: new Date().toISOString(),
      };
      const newAssistantMessage = {
        client_id: parseInt(id),
        content: response.data.response,
        is_client_message: false,
        is_manager_message: false, // Это сообщение ассистента
        timestamp: new Date().toISOString(),
      };

      setChatResponses([
        ...chatResponses,
        newClientMessage,
        newAssistantMessage,
      ]);
      setUserMessage(""); // Очищаем поле сообщения
    } catch (error) {
      console.error("Ошибка при общении с ChatGPT:", error);
      if (error.response) {
        console.error("Детали ошибки:", error.response.data);
        alert(
          "Ошибка при соединении с сервером: " +
            JSON.stringify(error.response.data)
        );
      } else {
        alert("Не удалось подключиться к ChatGPT.");
      }
    }
  };

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Чат с ChatGPT для клиента {id}
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        ID клиента: {id}
      </Typography>
      <div style={{ display: "flex", gap: "1rem", marginBottom: "2rem" }}>
        <TextField
          label="Ваше сообщение"
          value={userMessage}
          onChange={(e) => setUserMessage(e.target.value)}
          variant="outlined"
          fullWidth
        />
        <Button variant="contained" color="primary" onClick={sendMessage}>
          Отправить
        </Button>
      </div>
      <List>
        {chatResponses.map((chat, index) => (
          <ListItem key={index} alignItems="flex-start">
            <ListItemText
              primary={
                chat.is_client_message
                  ? `Клиент: ${chat.content}`
                  : chat.is_manager_message
                  ? `Менеджер: ${chat.content}`
                  : `Ассистент: ${chat.content}`
              }
              secondary={new Date(chat.timestamp).toLocaleString()}
            />
          </ListItem>
        ))}
      </List>
    </Container>
  );
}

export default Chat;
